<template>
  <div class="hero-container">
    <!-- Fundal -->
    <div class="landscape">
      <div class="mountain"></div>
      <div class="mountain mountain-2"></div>
      <div class="mountain mountain-3"></div>
      <div class="sun-container sun-container-1"></div>
      <div class="sun-container">
        <div class="sun"></div>
      </div>
      <div class="cloud"></div>
      <div class="cloud cloud-1"></div>
      <div class="sun-container sun-container-reflection">
        <div class="sun"></div>
      </div>
      <div class="water"></div>
      <div class="ferry"></div>
      <div class="splash"></div>
      <div class="splash delay-1"></div>
      <div class="splash delay-2"></div>
      <div class="splash splash-4 delay-2"></div>
      <div class="splash splash-4 delay-3"></div>
      <div class="splash splash-4 delay-4"></div>
      <div class="splash splash-stone delay-3"></div>
      <div class="splash splash-stone splash-4"></div>
      <div class="splash splash-stone splash-5"></div>
    </div>

    <!-- Textul Banner-ului (poziționat peste fundal) -->
    <section class="banner">
      <h1 class="display-4 fw-bold animate__animated animate__fadeInDown">
        {{ $t('banner.title') }}
      </h1>
      <h4 class="display-6 animate__animated animate__fadeInUp">
        {{ $t('banner.subtitle') }}
      </h4>
      <a href="https://feribot-eurobac.ro/bilete" class="btn btn-primary btn-lg mt-3 animate__animated animate__zoomIn">
        <i class="fa fa-ticket"></i> {{ $t('banner.button') }}
      </a>
    </section>
  </div>
</template>


<script>
export default {
  name: "HeroHome",
};
</script>

<style>
.btn-primary {
  background-color: #001F3F;
  border: none;
}

.btn-primary:hover {
  background-color: #002A5F; /* Albastru mai închis pentru hover */
}
:root {
  --v1: #28dfff; /* un albastru natural, mai calm */
  --s1: #89b0b7; /* un albastru deschis, calm */
  --v2: #55778e; /* un albastru mai închis pentru munți */
  --v3: #b1c9d6; /* un albastru foarte deschis pentru nori */
  --v5: #b1c9d6; /* un yellow foarte deschis pentru sand */
  --v4: #8e7b5f; /* un maro natural pentru pietre */
  --s2: #52a830; /* o nuanță verde închis pentru iarbă */
  --s3: #17e1fc; 
  --cloud: #dcdcdc; /* un gri natural pentru nori */
  --transparentv3: rgba(163, 201, 209, 0.5); /* transparent pentru lotusuri */
}

.landscape:after,
.landscape:before,
.landscape *,
.landscape *:after,
.landscape *:before {
  position: absolute;
}

.front {
  z-index: 1;
  bottom: 0;
  left: 0;
  right: 0;
}

.landscape {
  height: 80vh; /* Dimensiune mai mică pentru hero */
  background-image: linear-gradient(var(--v1), var(--s1), var(--v1));
  position: relative;
  z-index: 1;
  overflow: hidden;
  width: 100%; /* Asigură că lățimea este completă */
}

.mountain {
  border-radius: 180% 80% 0% 0%/60vmin 60vmin 0% 0%;
  width: 40vmin;
  height: 30vmin;
  bottom: 50%;
  left: -10vmin;
  background: var(--s1);
  background-image: linear-gradient(var(--v1), var(--v2) 30%, var(--v3));
  box-shadow: inset -10px 0 10px -10px var(--s1);
}

.mountain-2 {
  left: 5vmin;
  height: 15vmin;
  width: 40vmin;
  box-shadow: inset -15px 0 10px -14px var(--s1);
  border-radius: 120% 50% 0% 0%/25vmin 25vmin 0% 0%;
  background-image: linear-gradient(var(--v3), var(--v4));
}

.mountain-3 {
  border-radius: 80% 0% 0 0/100% 100% 0 0;
  right: -85vmin;
  width: 100vmin;
  left: auto;
  height: 12vmin;
  color: var(--v3);
  background-image: linear-gradient(var(--s1), var(--v4));
  box-shadow: inset 15px 0 10px -10px var(--s1);
}

.mountain-3:after {
  content: "";
  border-radius: 60% 0 0 0/100% 0 0 0;
  background: inherit;
  width: 100%;
  height: 0;
  bottom: 0;
  right: 20%;
}

.cloud {
  width: 80vmin;
  height: 6vmin;
  background: currentcolor;
  color: var(--cloud);
  top: 24vmin;
  left: 20vmin;
  border-radius: 50%;
  box-shadow: 30vmin 0.5vmin 0 -1vmin currentcolor,
    -25vmin 0 0 -0.6vmin currentcolor;
  opacity: 0.3;
  transform: translate3d(-150vmin, 0, 0);
  animation: clouds 120s infinite;
  animation-delay: -10s;
}

@keyframes clouds {
  50% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(150vmin, 0, 0);
  }
}

.cloud-1 {
  left: 60vmin;
  top: 15vmin;
  opacity: 0.2;
  filter: blur(1px);
  animation-delay: 0;
  animation-duration: 100s;
}

.water {
  top: 50%;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(#1ea9cc55, #0b6bb9);
  overflow: hidden;
  box-shadow: inset 0 1px 4px -3px white;
}

.stone {
  bottom: -5vh;
  left: 0;
  height: 20vmin;
  width: 40vmin;
  background: var(--v2);
  box-shadow: inset 0 0 20px -5px rgba(0, 0, 0, 0.2);
  border-radius: 0% 200% 0 0/0% 200%;
}

.stone:after {
  content: "";
  background: var(--v3);
  width: 100%;
  height: 100%;
  right: -15%;
  border-radius: inherit;
  z-index: -1;
  transform: scaleX(1.3) skew(10deg);
  box-shadow: inset 0 0 20px -5px rgba(0, 0, 0, 0.4);
}

.sun {
  background: rgb(255, 218, 52);
  border-radius: 50%;
  width: 20vmin;
  height: 20vmin;
  left: calc(70%);
  top: 30%;
  transform: translate3d(0, 0, 0);
  box-shadow: 0 0 10px white;
}

.sun-container {
  overflow: hidden;
  width: 100%;
  height: 50%;
}

.sun-container-reflection {
  top: 50%;
  background: radial-gradient(circle at 60% 0%, var(--s3), transparent);
}

.sun-container-reflection .sun {
  background: linear-gradient(white, rgba(255, 255, 255, 0));
  box-shadow: none;
  filter: blur(5px);
  opacity: 1;
  top: 90;
  transform: translate3d(0, -20vmin, 0);
  animation-name: rise-reflection;
}

@keyframes rise-reflection {
  30% {
    opacity: 0;
    transform: translate3d(0, 5vmin, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, 80vmin, 0);
  }
}
/* Stilizare generală pentru banner */
/* 🔹 Asigură că containerul ține totul împreună */
.hero-container {
  position: relative;
  width: 100%;
  height: 80vh;
  overflow: hidden;
}

/* 🔹 Fundal complet */
.landscape {
  width: 100%;
  height: 80%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1; /* Fundalul rămâne dedesubt */
}

/* 🔹 Poziționăm banner-ul peste fundal */
.banner {
  position: absolute;
  top: 50%; /* Centrare verticală */
  left: 50%; /* Centrare orizontală */
  transform: translate(-50%, -50%);
  text-align: center;
  width: 90%;
  margin-top: -40px;
  max-width: 800px;
  z-index: 10; /* Asigură că textul e peste fundal */
  color: white;
}

/* 🔹 Dimensiuni text */
.banner h1 {
  font-size: 3rem;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
}

.banner h4 {
  font-size: 1.5rem;
  font-weight: normal;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  margin-bottom: 20px;
}

/* 🔹 Buton */
.banner a {
  font-size: 1.2rem;
  text-decoration: none;
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  transition: background-color 0.3s ease-in-out;
  display: inline-block;
}

.banner a:hover {
  background-color: #0056b3;
}

/* 🔹 Ajustare pentru mobil */
@media (max-width: 768px) {
  .banner {
    width: 100%;
    padding: 10px;
    top: 55%; /* Ajustează poziția textului */
  }

  .banner h1 {
    font-size: 2rem;
  }

  .banner h4 {
    font-size: 1.2rem;
  }

  .banner a {
    font-size: 1rem;
    padding: 8px 15px;
  }
}



/* Feribotul ca div */
.ferry {
  position: absolute;
  top: 40%; /* Poziționăm feribotul mai sus */
  left: 50%;
  transform: translateX(-90%) translateY(-40%);
  width: 600px;
  height: 600px;
  background-image: url("../assets/ferry.png");
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 2;
}

.splash {
  width: 8vmin;
  height: 3vmin;
  border: 2px solid var(--s1);
  box-shadow: 0 0 2px var(--s1);
  border-radius: 50%;
  bottom: 5vmin;
  left: 70%;
  animation: splash 9s infinite;
  transform: scale(0);
}

.splash-stone {
  bottom: 15vh;
  left: -3vmin;
  height: 10vmin;
  width: 30vmin;
}

.splash-4 {
  bottom: 5vmin;
  left: auto;
  bottom: 15vmin;
  right: -2vmin;
}

@keyframes splash {
  50%,
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.delay-1 {
  animation-delay: 1s;
}
.delay-2 {
  animation-delay: 2s;
}
.delay-3 {
  animation-delay: 3s;
}
.delay-4 {
  animation-delay: 4s;
}
.delay-5 {
  animation-delay: 5s;
}
.delay-6 {
  animation-delay: 6s;
}

/* Textul din secțiunea de banner */
.banner {
  position: absolute; /* Poziționează secțiunea în mod absolut pe ecran */
  top: 50%; /* Plasează secțiunea pe mijloc pe verticală */
  left: 50%; /* Plasează secțiunea pe mijloc pe orizontală */
  transform: translate(-50%, -50%); /* Centrează textul în mod corect */
  text-align: center; /* Aliniază textul pe centru */
  color: white; /* Asigură-te că textul este alb */
  z-index: 3; /* Asigură-te că textul apare deasupra celorlalte elemente */
}

/* Pentru titlul h1 */
h1 {
  font-weight: bold;
  font-size: 3em; /* Poți ajusta dimensiunea fontului */
  color: white; /* Text alb */
   /* Fundal semitransparent */
  padding: 10px; /* Un pic de padding pentru a face textul mai lizibil */
  border-radius: 5px; /* Colțuri rotunjite pentru un aspect mai plăcut */
}

/* Pentru subtitlu p */
h4 {
  font-weight: bold;
  font-size: 3em; /* Poți ajusta dimensiunea fontului */
  color: white; /* Text alb */
   /* Fundal semitransparent */
  padding: 10px; /* Un pic de padding pentru a face textul mai lizibil */
  border-radius: 5px; /* Colțuri rotunjite pentru un aspect mai plăcut */
}




</style>
